import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=8cca2190&scoped=true"
import script from "./AvatarComponent.vue?vue&type=script&lang=ts"
export * from "./AvatarComponent.vue?vue&type=script&lang=ts"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=8cca2190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cca2190",
  null
  
)

export default component.exports